export default "__VITE_ASSET__Cy1Qu_MZ__"